export const baseUrl = `https://techpaver.com`;
